import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { Typography } from "antd";
import { Link } from "react-router-dom";

const { Paragraph, Title } = Typography;

const ExploreAttractions = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Fetch products with sub categories
        const res = await axiosInstance.get(
          "/products?populate=sub_products"
        );

        const data = res?.data?.data || [];

        // ✅ Convert into sub-category list
        const subCategoryList = data.flatMap((product) =>
          (product.sub_products || [])
            .filter((sub) => !sub.is_hidden)
            .map((sub) => ({
              id: sub.id,
              title: sub.title,
              productSlug: product.slug,
              subProductSlug: sub.slug,
            }))
        );

        setItems(subCategoryList);
      } catch (err) {
        console.error("API Error:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="container">
      {/* Heading */}
      <div className="flex justify-center items-center mb-6 font-medium">
        <div>
          <Title
            className="!font-medium !text-danger !text-2xl !mb-1 text-center"
            level={2}
          >
            <span className="text-primary">Explore more on </span> Efficient
            Tourism
          </Title>
          <Paragraph className="!mb-0 text-center">
            Culture, nature, thrills, and record-breaking experiences
          </Paragraph>
        </div>
      </div>

      {/* ✅ 4-column grid (Sub Categories) */}
      <div className="grid grid-cols-4 overflow-hidden">
        {Array.from({ length: 4 }).map((_, colIdx) => (
          <div
            key={colIdx}
            className="last:border-r-0 px-4 lg:first:pl-0 lg:last:pr-0 space-y-4"
          >
            {items
              .filter((_, i) => i % 4 === colIdx)
              .map((item, idx) => {
                const number = colIdx + 1 + idx * 4;

                // ✅ Updated URL (NO item.slug)
                const url = `/activity/${item.productSlug}/${item.subProductSlug}`;

                return (
                  <Link key={item.id} to={url} className="block">
                    <div className="flex items-center h-9 cursor-pointer hover:bg-gray-100 transition">
                      
                      {/* Number Box */}
                      <span className="flex items-center justify-center h-full flex-1 bg-danger border border-danger text-white rounded-l text-sm font-semibold text-center">
                        {number}
                      </span>

                      {/* Title */}
                      <span
                        title={item.title}
                        className="pl-3 flex items-center h-full flex-[4] min-w-0 border rounded-r text-xs font-normal"
                      >
                        <span className="truncate w-full">
                          {item.title}
                        </span>
                      </span>

                    </div>
                  </Link>
                );
              })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExploreAttractions;